import SearchArea from './main'
// import SearchArea from './main-grid'

export default SearchArea

export const addComponent = (name, component) => {
  SearchArea.components = Object.assign({}, SearchArea.components, { [name]: component })
}
